module.exports = {
      id: "product-close-circle-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "images/sprites.min-1c08d51c273150e6e08e418214dcfa8a.svg#product-close-circle-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./client/src/site__scf001/components/site/sprites/product-close-circle.svg
// module id = /home/vsts/work/1/s/src/SCF/node_modules/svg-sprite-loader/lib/loader.js??ref--12-0!/home/vsts/work/1/s/src/SCF/client/src/site__scf001/components/site/sprites/product-close-circle.svg
// module chunks = site__scf001